import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'

import {
  updateTablesAction,
  clearTables,
} from 'containers/Entity/actions'

import {
  get,
  post
} from 'helpers/RequestUtil'

import {
  UPDATE_ACTIVE_DIALOG,
  DIALOG_TYPE
} from 'containers/Admin/Client/Client/constants'

import {
  POST_CLIENT,
} from './constants'

import {
  formSelector
} from './selectors'

import {
  fetchClients,
} from 'containers/Admin/Client/ClientSelection/actions'

import {
  resetForm,
  postClientStart,
  postClientSuccess,
  postClientError,
  startPostClientAsync,
} from './actions'

function* postClient(form) {
  try {
    yield put(startPostClientAsync())
    yield put(postClientStart())
    const data = yield call(
      post,
      'clients',
      { ...form },
      '/api/fulcrum/clients'
    )
    yield put(postClientSuccess())
    return data
  } catch(error) {
    yield put(postClientError(error))
  }
}

function* handlePostClient() {
  const form = yield select(formSelector)
  yield call(postClient, form)
  yield put(fetchClients())
}

function* handleUpdateActiveDialog(action) {
  if (action.value === DIALOG_TYPE.CREATE)
    yield put(resetForm())
}

function* watchUpdateActiveDialog() {
  yield takeLatest(UPDATE_ACTIVE_DIALOG, handleUpdateActiveDialog)
}

function* watchPostClient() {
  yield takeEvery(POST_CLIENT, handlePostClient)
}

function* loadSagas() {
  yield all([
    fork(watchPostClient),
    fork(watchUpdateActiveDialog),
  ])
}

export default loadSagas
